import { blogCategories } from '../../../mocks/blog';

interface CategoryFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({ activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <section className="bg-cream-100 py-8 sticky top-0 z-40 border-b border-gold-200/60">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-center gap-3 flex-wrap">
          {blogCategories.map((category) => (
            <button
              key={category.slug}
              onClick={() => onCategoryChange(category.slug)}
              className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-sm ${
                activeCategory === category.slug
                  ? 'bg-gradient-to-r from-gold-500 to-gold-600 text-white scale-105'
                  : 'bg-cream-50 text-charcoal-500 hover:bg-gold-50 hover:text-gold-700 border border-gold-200/80'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
